import constantStyles from "!!sass-variable-loader!Styles/Constants.scss";
import { createMuiTheme } from "@material-ui/core/styles";

export default createMuiTheme({
    typography: {
        useNextVariants: true
    },
    overrides: {
        MuiButton: {
            root: {
                textTransform: "none",
                outline: "none"
            }
        },
        MuiCheckbox: {
            root: {
                padding: 0,
                color: constantStyles.primaryColor
            }
        },
        MuiSlider: {
            root: {
                color: constantStyles.primaryColor
            }
        }
    }
});


// WEBPACK FOOTER //
// ./src/Styles/MaterialUITheme.tsx